import React, { useEffect, useRef, useState } from 'react'

function UserPrompt({ textValue, index, handleDeleteUserPrompt, handleUpdateUserPrompt }) {

    const [isInput, setIsInput] = useState(false);
    const [inputtext, setInputtext] = useState(textValue || "")
    const textareaRef = useRef(null);

    useEffect(() => {
        if (textareaRef && textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
        }
    }, [inputtext]);


    const handleInputChange = (e) => {
        const { value } = e.target;
        setInputtext(value);

        // Update textarea height as user types
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
        }
    };

    return (
        <div className="group md:px-4 border-b border-black/10 bg-white text-gray-800" style={{ overflowWrap: "anywhere" }}>
            <div className="relative m-auto flex p-4 text-base md:max-w-2xl md:gap-6 md:py-6 lg:max-w-2xl lg:px-0 xl:max-w-3xl">
                <div className="min-w-[40px] text-right font-bold">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-user">
                        <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                        <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
                    </svg>
                </div>
                <div className="prose mt-[-2px] w-full">

                    {
                        isInput ? <div className="prose mt-[-2px] w-full dark:prose-invert">
                            <div className="flex w-full">
                                <div className="flex w-full flex-col">
                                    <textarea ref={textareaRef} value={inputtext} onChange={handleInputChange}
                                        className="w-full h-max resize-none whitespace-pre-wrap border-none" style={{
                                            fontFamily: 'inherit',
                                            fontSize: 'inherit',
                                            lineHeight: 'inherit',
                                            padding: '0px',
                                            margin: '0px'
                                        }}>

                                    </textarea>
                                    <div className="mt-10 flex justify-center space-x-4">
                                        <button onClick={() => {
                                            handleUpdateUserPrompt(index, inputtext)
                                            setIsInput(false)
                                        }} className="h-[40px] rounded-md bg-blue-500 px-4 py-1 text-sm font-medium text-black enabled:hover:bg-blue-600 disabled:opacity-50">Save &amp; Submit</button>
                                        <button onClick={() => {
                                            setIsInput(false)
                                            setInputtext(textValue)
                                        }} className="h-[40px] rounded-md border border-neutral-300 px-4 py-1 text-sm font-medium text-neutral-700 hover:bg-neutral-100">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                            : <div className="flex w-full">
                                <div className="prose whitespace-pre-wrap flex-1">{inputtext}</div>
                                <div className="md:-mr-0 ml-1 md:ml-0 flex flex-col md:flex-row gap-4 md:gap-1 items-center md:items-start justify-end md:justify-start">
                                    <button onClick={() => {
                                        setIsInput(true);
                                    }} className="invisible group-hover:visible focus:visible text-gray-500 hover:text-gray-70">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-edit">
                                            <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"></path>
                                            <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z"></path>
                                            <path d="M16 5l3 3"></path>
                                        </svg>
                                    </button>
                                    <button onClick={() => handleDeleteUserPrompt(index)} className="invisible group-hover:visible focus:visible text-gray-500 hover:text-gray-700">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-trash">
                                            <path d="M4 7l16 0"></path>
                                            <path d="M10 11l0 6"></path>
                                            <path d="M14 11l0 6"></path>
                                            <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
                                            <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                    }


                </div>
            </div>
        </div>
    )
}

export default UserPrompt